import { useEffect, useRef, useState } from 'react';

export const usePagination = (
  hasNextPage: boolean = false,
  callBackFun: Function
) => {
  const [page, setPage] = useState(1);
  const calling = useRef(false);
  const lastHeight = useRef(0);

  const handleScroll = () => {
    const bottom =
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 50;

    if (lastHeight.current !== document.documentElement.offsetHeight) {
      lastHeight.current = document.documentElement.offsetHeight;
      calling.current = false;
    }

    if (bottom && hasNextPage && !calling.current) {
      calling.current = true;
      callBackFun(page + 1);
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  // Adding scroll event listener on component mount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll); // Cleanup on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNextPage, page, callBackFun]);

  return { page };
};
